import * as React from 'react';
import { useMemo } from 'react';
import { RouterContentContext, RouterControllerContext, RouterPendingContext, RouterRequestContext, } from '../routerContext';
export function RouterProvider(_a) {
    var children = _a.children, value = _a.value;
    var block = value.block, navigate = value.navigate, prefetch = value.prefetch, waitUntilNavigationCompletes = value.waitUntilNavigationCompletes;
    var controller = useMemo(function () { return ({
        block: block,
        navigate: navigate,
        prefetch: prefetch,
        waitUntilNavigationCompletes: waitUntilNavigationCompletes,
    }); }, [block, navigate, prefetch, waitUntilNavigationCompletes]);
    return (React.createElement(RouterControllerContext.Provider, { value: controller },
        React.createElement(RouterRequestContext.Provider, { value: value.request },
            React.createElement(RouterContentContext.Provider, { value: value.content },
                React.createElement(RouterPendingContext.Provider, { value: !!value.pending }, children)))));
}
